// The brand mark: two interlocking rings, one honey and one sage
// (KESHER_BRAND_GUIDE.md §5.1) — neither ring is a closed, complete shape on
// its own, the mark only reads as whole with both present and overlapping.
// Colors are fixed (not `currentColor`) because §5.4 keeps the mark
// full-color on every surface, light or dark — only the wordmark next to it
// swaps to cream on a dark surface, not the rings themselves.
//
// Geometry is brand/assets/mark-color.svg's own paths, inlined (rather than
// loaded via <img>) so it stays crisp at any `size` with no network fetch -
// the same approach every other copy of this mark in the codebase takes.
// Three other places hand-roll the identical shape and must be kept in sync
// if this geometry ever changes again: live/FirstRunPanel.jsx's and
// live/ChoosePlanPanel.jsx's own `RingMotif` (a softened, scaled-up copy),
// and backend/core/email_templates.py's `_MARK_SVG` (inlined there instead
// of an <img> for the same crispness reason, plus most mail clients block
// remote images by default).
export function Logo({ size = 18, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path d="M 27.36 73.65 A 34 34 0 1 1 57.14 75.36" stroke="#DB9A45" strokeWidth="11" strokeLinecap="round" />
      <path d="M 92.64 46.35 A 34 34 0 1 1 62.86 44.64" stroke="#7C8A5E" strokeWidth="11" strokeLinecap="round" />
    </svg>
  );
}
